<template>
  <div class="adver">
    <ul>
      <li>
        <img src="../assets/宣传页1.jpg" alt>
      </li>
      <li>
        <img src="../assets/宣传页2.jpg" alt>
      </li>
      <li>
        <img src="../assets/宣传页3.jpg" alt>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.adver {
  background: #fbc701;
  font-size: 0px;
  padding: 0 80px;
  ul {
    list-style: none;
  }
  img {
    width: 100%;
  }
}
</style>

